<template>
    <section name="hero" class="hero_sb" :style="!content.banner ? '' : 'background: url(' + content.banner + ')'">
        <div class="background-filter">
            <div class="wrapper hero_content">
                <h1>{{content.title}}</h1>
                <p>
                    {{content.description}}
                </p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        content: {
            required: true,
        },
    }
}
</script>
